import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconErrorCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM6.46875 5.46875C6.15625 5.78125 6.15625 6.25 6.46875 6.53125L7.9375 8L6.46875 9.46875C6.15625 9.78125 6.15625 10.25 6.46875 10.5312C6.75 10.8438 7.21875 10.8438 7.5 10.5312L8.96875 9.0625L10.4375 10.5312C10.75 10.8438 11.2188 10.8438 11.5 10.5312C11.8125 10.25 11.8125 9.78125 11.5 9.46875L10.0312 8L11.5 6.53125C11.8125 6.25 11.8125 5.78125 11.5 5.46875C11.2188 5.1875 10.75 5.1875 10.4375 5.46875L8.96875 6.9375L7.5 5.46875C7.21875 5.1875 6.75 5.1875 6.46875 5.46875Z",
		fill: "#D91734"
	})]
});
const ForwardRef = forwardRef(SvgIconErrorCircle);
export { ForwardRef as ReactComponent };
